import { email, helpers, required } from '@vuelidate/validators'
import { computed, Ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { SignupFormData } from '@/composables/signup/useSignupFormData'
import useValidation from '@/composables/validations/useValidation'

import { regExPassword, regExUsername } from '@/app/regularExpressions'

export default (formData: Ref<SignupFormData>) => {
  const { t } = useI18n()

  const validationRules = computed(() => ({
    email: {
      required: helpers.withMessage(t('errors.required'), required),
      emailTemplate: helpers.withMessage(t('errors.emailTemplate'), email),
    },
    companyName: {
      required: helpers.withMessage(t('errors.required'), required),
    },
    social: {
      required: helpers.withMessage(t('errors.required'), required),
    },
    username: {
      required: helpers.withMessage(t('errors.required'), required),
      usernameTemplate: helpers.withMessage(
        t('errors.usernameTemplate'),
        helpers.regex(regExUsername),
      ),
    },
    password: {
      required: helpers.withMessage(t('errors.required'), required),
      passTemplate: helpers.withMessage(
        t('errors.passTemplate'),
        helpers.regex(regExPassword),
      ),
    },
  }))

  return useValidation(validationRules, formData)
}
